module.exports = __webpack_public_path__ + "assets/GoldChi2x.43c83736df0952ed24b0299c0910e2d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldChi2x.png
// module id = 806
// module chunks = 0